import { render, staticRenderFns } from "./report-prf-soft-competency.vue?vue&type=template&id=5ad932f6"
import script from "./report-prf-soft-competency.vue?vue&type=script&lang=js"
export * from "./report-prf-soft-competency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports